<script setup>
import { DropdownMenuRoot } from 'radix-vue';
import { computed } from 'vue';

const props = defineProps({
  open: { type: Boolean, required: false },
  defaultOpen: { type: Boolean, required: false },
  modal: { type: Boolean, required: false },
  dir: { type: String, required: false },
});

const emits = defineEmits(['update:open']);

const delegatedProps = computed(() => {
  const { ...delegated } = props;
  return delegated;
});
</script>

<template>
  <DropdownMenuRoot
    v-bind="delegatedProps"
    :open="open"
    @update:open="emits('update:open', $event)"
  >
    <slot />
  </DropdownMenuRoot>
</template> 